var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6172 5.5V3.5H7.11719V6.5V7H6.61719H3.61719V12.5H10.6172V11.5H11.6172V12.5V13.5H10.6172H3.61719H2.61719V12.5V5.5L5.61719 2.5H7.11719H10.6172H11.6172V3.5V5.5H10.6172ZM6.0314 3.5H6.11719V6H3.61719V5.91421L6.0314 3.5Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1387 6.75592L10.8406 8.05401L9.54253 6.75592L9.43646 6.64985L9.3304 6.75592L8.97936 7.10696L8.87329 7.21302L8.97936 7.31909L10.2775 8.61719L9.02735 9.86729L8.92128 9.97336L9.02735 10.0794L9.37839 10.4305L9.48446 10.5365L9.59052 10.4305L10.8406 9.18036L12.1387 10.4785L12.2448 10.5845L12.3509 10.4785L12.7019 10.1274L12.808 10.0214L12.7019 9.91529L11.4038 8.61719L12.7019 7.31909L12.808 7.21302L12.7019 7.10696L12.3509 6.75592L12.2448 6.64985L12.1387 6.75592Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileOff);
export default __webpack_public_path__ + "static/media/icon-file-off.78c444d70a27ff640cddd89436cd3338.svg";
export { ForwardRef as ReactComponent };